import { render } from "./AboutUsCards.vue?vue&type=template&id=4771ad42"
import script from "./AboutUsCards.vue?vue&type=script&lang=js"
export * from "./AboutUsCards.vue?vue&type=script&lang=js"

import "./AboutUsCards.vue?vue&type=style&index=0&id=4771ad42&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__